import React, { createContext, useContext, useMemo, useState } from "react";

const ActionRegistryContext = createContext();

export const useActionRegistry = () => useContext(ActionRegistryContext);

export const ActionRegistryProvider = ({ children }) => {
  const [actions, setActions] = useState({});

  const registerAction = (id, handler) => {
    setActions((prev) => ({ ...prev, [id]: handler }));
  };

  const getAction = (id) => actions[id];

  const value = useMemo(() => ({ registerAction, getAction }), [actions]);

  return (
    <ActionRegistryContext.Provider value={value}>
      {children}
    </ActionRegistryContext.Provider>
  );
};
